import React, { memo, useEffect, useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import Logo from "../images/logo.svg";
import personIcon from "../images/person.svg";

import {
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CircleImg from "../images/circle-pattern-1.png";
import ArrowDown from "../images/arrow-down.svg";
import VisibilityOff from "../images/eye-close.svg";
import Visibility from "../images/eye-icon.svg";
import LockIcon from "../images/lock_icon.svg";
import refrechIcon from "../images/refresh-icon.svg";
import captchaIcon from "../images/re-load.svg";
import emailIcon from "../images/email-icon.svg";
import phoneIcon from "../images/phone-icon.svg";
import backIcon from "../images/back-arrow-left.svg";
import { useNavigate, Link } from "react-router-dom";
import {
  DASHBOARD_ROUTE,
  FORGOT_PASSWORD,
  SIGNIN_ROUTE,
} from "../constants/RoutePath";
import { useFormik } from "formik";
import * as Yup from "yup";

// import {
//   loadCaptchaEnginge,
//   LoadCanvasTemplate,
//   LoadCanvasTemplateNoReload,
//   validateCaptcha,
// } from "react-simple-captcha";

import { SIGN_UP_URL } from "../constants/ApiRoute";
import { CustomMessage, deCryptFun, enCryptFun } from "./comman/CustomFunction";
import API from "./comman/API";
import CustomLoader from "./comman/CustomLoader";

import Captcha from "./comman/Captcha";
import CreateNewAccountModel from "./model/CreateNewAccountModel";
import EmailSchema from "./comman/validation/EmailSchema";
import { useToast } from "./comman/CustomMessages";
import {
  allowedCharactersRegex,
  phoneNumberRegex,
  prohibitedCharsRegex,
} from "./comman/RegexConstant";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));
const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  password: "",
  confirmPassword: "",
  captcha: "",
};
const Signup = () => {
  const navigate = useNavigate();
  const showToast = useToast();

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = React.useState(true);
  const [confirmshowPassword, confirmsetShowPassword] = React.useState(true);
  const [enData, setEnDate] = useState("");
  const [onChaptcha, setOnChaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [flag, setFlag] = useState(false);
  const inputRef = useRef(null);
  const inputRefconf = useRef(null);
  const captchaRef = useRef(null);

  const validationSchema = Yup.object({
    firstName: Yup.string()
      .trim()
      .required("First name is required")
      .matches(allowedCharactersRegex, "Invalid first name")
      .min(1, "First name must be at least 1 character")
      .max(50, "First name cannot exceed 50 characters"),

    lastName: Yup.string()
      .trim()
      .required("Last name is required")
      .matches(allowedCharactersRegex, "Invalid last name")
      .min(1, "Last name must be at least 1 character")
      .max(50, "Last name cannot exceed 50 characters"),
    phoneNumber: Yup.string()
      .trim()
      .required("Phone number is required")
      // .matches(/^\+1 \(\d{3}\) \d{3}-\d{4}$/, 'Phone number is not valid')
      .matches(phoneNumberRegex, "Invalid phone number")
      .min(7, "Phone number must be at least 7 digits long")
      .max(15, "Phone number cannot be longer than 15 digits"),
    email: EmailSchema.required("Email is required"),
    password: Yup.string()
      .required("Password is required")
      .min(7, "Password must be at least 7 characters")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[0-9]/, "Password must contain at least one number"),
    confirmPassword: Yup.string()
      .required("Please confirm your password.")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
    captcha: Yup.string()
      .matches(/^[^a-z]*$/, "Captcha should not contain lowercase letters")
      .required("Captcha is required"),
  });
  const {
    handleSubmit,
    handleChange,
    setValues,
    values,
    errors,
    setErrors,
    touched,
    resetForm,
    handleBlur,
    setFieldTouched,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      captchaValidation(values);
    },
  });
  // useEffect(() => {
  //   loadCaptchaEnginge(6);
  // }, []);
  const handleClose = () => {
    setFlag(false);
    resetForm({});
    setValues(initialValues);
    document.getElementById("user_captcha_input").value = "";
  };
  const Registeruser = async (values) => {
    setLoading(true);

    const data = {
      firstName: values.firstName.trim(),
      lastName: values.lastName.trim(),
      email: values.email,
      password: values.password,
      phoneNumber: values.phoneNumber,
      linkUrl: window.location.origin + "/email-confirmation/",
    };

    const config = {
      method: "POST",
      url: SIGN_UP_URL,
      data: {
        webString: enCryptFun(JSON.stringify(data)),
        flutterString: "",
      },
    };
    try {
      const response = await API(config);
      console.log("response", response);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      console.log("response", parsedResponse);
      if (parsedResponse.status === "Success") {
        setFlag(true);
        //showToast"Signup successful", "success", enqueueSnackbar);
        // navigate(DASHBOARD_ROUTE);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
        if (captchaRef.current) {
          captchaRef.current.captchaReload();
        }
        document.getElementById("user_captcha_input").value = "";
      }
    } finally {
      if (captchaRef.current) {
        captchaRef.current.captchaReload();
      }
      setLoading(false);
      setCaptchaInput("");
    }
  };
  const captchaValidation = async (values) => {
    if (onChaptcha === values.captcha) {
      Registeruser(values);
      // resetForm();
    } else {
      //setErrors({ ...errors, captcha: "Enter valid captcha" });
      if (captchaRef.current) {
        captchaRef.current.captchaReload();
      }
      showToast(
        "Invalid captcha validation. To ensure this is a legitmate request and not one initiated by an automated script (aka 'Bot'), please enter the text in the image exactly as it appears. If you cannot read the text in the image then you can click the refresh button to receive a new image.",
        "error"
      );
      setValues((prevValues) => ({
        ...prevValues,
        captcha: "",
      }));
      document.getElementById("user_captcha_input").value = "";
      setCaptchaInput("");

      // setErrors({ ...errors, captcha: "Enter valid captcha" });
    }
  };

  const handleClickShowPassword = () => {
    const input = inputRef.current.querySelector("input");
    const cursorPosition = input.selectionStart;
    setShowPassword(!showPassword);
    // setTimeout(() => {
    //   input.setSelectionRange(cursorPosition, cursorPosition);
    // }, 0);
    // requestAnimationFrame(() => {
    //   // Set the cursor position to the end of the input
    //   const endPosition = input.value.length;
    //   input.setSelectionRange(endPosition, endPosition);
    // });
    requestAnimationFrame(() => {
      input.blur(); // This removes the cursor by blurring the input field
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleClickShowPasswordConfirm = () => {
    const input = inputRefconf.current.querySelector("input");
    const cursorPosition = input.selectionStart;
    confirmsetShowPassword(!confirmshowPassword);
    // setTimeout(() => {
    //   input.setSelectionRange(cursorPosition, cursorPosition);
    // }, 0);
    // requestAnimationFrame(() => {
    //   // Set the cursor position to the end of the input
    //   const endPosition = input.value.length;
    //   input.setSelectionRange(endPosition, endPosition);
    // });
    requestAnimationFrame(() => {
      input.blur(); // This removes the cursor by blurring the input field
    });
  };

  const handleMouseDownPasswordconfirm = (event) => {
    event.preventDefault();
  };

  const handleCaptchaChange = (newCaptcha) => {
    setOnChaptcha(newCaptcha);
  };

  const backFun = () => {
    navigate(SIGNIN_ROUTE);
  };
  // useEffect(() => {
  //   if (errors.password && touched.password) {
  //     if (errors.password) {
  //       showToast(errors.password, "error");
  //     }
  //   }
  // }, [errors.password, touched.password]);

  const [expanded, setExpanded] = React.useState(false);

  const handleChanges = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // const phoneNumberRegex1 = /^\+1\s?\(\d{3}\)\s?\d{3}-\d{4}$/;
  // const prohibitedCharsRegex = /[A-Za-z!@#$%^&*/={}\[\]|\\:;"'<>,?`]/;

  // const phoneNumberRegex = /^\+1\s?\(\d{3}\)\s?\d{3}-\d{4}$/;
  // const prohibitedCharsRegex = /[A-Za-z!@#$%^&*/={}\[\]|\\:;"'<>,?`]/;

  const handleChange1 = (e) => {
    const { name, value } = e.target;
  
    // Allow only letters, spaces, apostrophes, and hyphens
    let cleanedValue = value.replace(/[^a-zA-Z\s'-]/g, "");
  
    // Prevent space as the first character
    if (cleanedValue === " " || (cleanedValue.length === 1 && cleanedValue.startsWith(" "))) {
      cleanedValue = "";
    }
  
    // Enforce a maximum character limit of 50
    if (cleanedValue.length > 50) {
      cleanedValue = cleanedValue.slice(0, 50);
    }
  
    // Update Formik's value
    setValues((prevValues) => ({
      ...prevValues,
      [name]: cleanedValue,
    }));
  
    // Optionally, you can also set touched and errors if needed
    setFieldTouched(name, true);
  };
  

  const formatPhoneNumber = (value) => {
    if (!value) return value;

    // Remove all non-digits except the + sign
    const phoneNumber = value.replace(/[^\d]/g, "");

    if (phoneNumber.length < 4) return `(${phoneNumber}`;
    if (phoneNumber.length < 7)
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    if (phoneNumber.length <= 10)
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
        3,
        6
      )}-${phoneNumber.slice(6)}`;

    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  };

  const handlePhoneNumberChange = (e) => {
    const { value } = e.target;
    console.log(value, "valueurrrrrrrrrrrrr");
    // Allow valid characters: digits, spaces, parentheses, dashes, and the plus sign
    const allowedCharactersRegex = /^[\d\s()+-]*$/;

    if (allowedCharactersRegex.test(value)) {
      console.log(value, "valueurrvaluevaluerrrrrrrrrrr");
      // Format the phone number as the user types
      const formattedPhoneNumber = formatPhoneNumber(value);
      console.log(
        formattedPhoneNumber,
        "formattedPhoneNumberformattedPhoneNumber"
      );
      // Update Formik's state with the formatted value
      handleChange(e);
      setValues({
        ...values,
        phoneNumber: formattedPhoneNumber,
      });
    }
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Grid container rowSpacing={1}>
          <Grid sx={{ p: "0 !important" }} item xs={12} md={6} lg={6}>
            <Box
              sx={{
                height: { xs: "auto", md: "93%" },
                padding: { xs: "40px", md: "40px 60px" },
                paddingRight: { xs: "40px", md: "68px" },
                paddingTop: "46px",
              }}
              className="welcome-box"
            >
              {/* <Box className="login-bg-color login-bg-top"></Box> */}
              <img className="logo" src={Logo} />
              <h1 className="login-title">
                Welcome to
                <br /> <span className="smart-billing">
                  Smart Billing
                </span> by <br />
                HOS Resources
              </h1>
              <p className="login-text">
                Smart Billing is the billing solution that enables HOS Resources
                to quickly collect, consolidate, and invoice billing statements
                from brokers in the field.
              </p>
              {/* <Box className="login-bg-color login-bg-bottom"></Box> */}
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChanges("panel1")}
                className="login-accord"
              >
                <AccordionSummary
                  expandIcon={<img src={ArrowDown} />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  About
                </AccordionSummary>
                <AccordionDetails>
                  HOS Resources, LLC (“HOS”) is a Lafayette, Louisiana based
                  energy consulting firm formed in 2015. HOS retains independent
                  contractor landmen to provide our clients with quality land
                  services throughout the country. These include title,
                  abstracting, curative, leasing, right-of-way acquisitions,
                  land acquisition, and any other services required to meet our
                  clients’ needs.
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChanges("panel2")}
                className="login-accord"
              >
                <AccordionSummary
                  expandIcon={<img src={ArrowDown} />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  Leadership & Experience
                </AccordionSummary>
                <AccordionDetails>
                  HOS’s founders combine for over 34 years of industry
                  experience in negotiating and acquiring oil and gas leases,
                  right-of-ways, seismic permits and options, as well as surface
                  leases throughout the country, including Louisiana,
                  Mississippi, Alabama, Texas, Utah, Minnesota, New York and
                  Illinois. They have represented oil and gas exploration
                  companies, midstream pipeline and storage companies, renewable
                  energy developers, law firms, large landowners, working
                  interest participants, private equity funds, and banks. HOS’s
                  senior landmen have over 50 years combined industry
                  experience.
                </AccordionDetails>
              </Accordion>
            </Box>
          </Grid>
          <Grid sx={{ background: "#fff" }} item xs={12} md={6} lg={6}>
            <Box
              sx={{
                padding: {
                  xs: "40px 30px",
                  md: "40px 40px 40px 20px",
                  lg: "40px 100px 40px 76px",
                },
                pt: "40px !important",
              }}
              className="form-box login"
            >
              <Stack
                sx={{
                  mb: "14px",
                  cursor: "pointer",
                  width: "fit-content",
                }}
                direction="row"
                spacing={0}
                justifyContent="flex-start"
                alignItems="center"
                onClick={backFun}
              >
                <img style={{ cursor: "pointer" }} src={backIcon} />
                <p className="back-text">Back</p>
              </Stack>
              <Typography className="form-title" variant="h2">
                Create a new account
              </Typography>
              <p className="form-text">
                Use the form below to create an account.
              </p>
              <Box component={"form"} onSubmit={handleSubmit}>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  justifyContent="space-between"
                >
                  <FormControl variant="standard">
                    <p className="label">First Name</p>
                    <Input
                      name="firstName"
                      placeholder="Enter first name"
                      type="text"
                      startAdornment={
                        <InputAdornment position="start">
                          <img src={personIcon} alt="Person Icon" />
                        </InputAdornment>
                      }
                      value={values.firstName}
                      onChange={(e) => {
                        handleChange1(e);
                        // handleChange(e);
                        if (touched.firstName) {
                          setFieldTouched("firstName", false);
                        }
                      }}
                      onBlur={handleBlur}
                      error={errors.firstName && touched.firstName}
                    />
                    <FormHelperText error={true}>
                      {errors.firstName && touched.firstName
                        ? errors.firstName
                        : ""}
                    </FormHelperText>
                  </FormControl>
                  <FormControl className="s-lastname" variant="standard">
                    <p className="label">Last Name</p>
                    <Input
                      name="lastName"
                      placeholder="Enter last name"
                      id="input-with-icon-adornment"
                      startAdornment={
                        <InputAdornment position="start">
                          <img src={personIcon} />
                        </InputAdornment>
                      }
                      value={values.lastName}
                      onChange={(e) => {
                        handleChange1(e);
                        if (touched.lastName) {
                          setFieldTouched("lastName", false); // Clear touched state
                        }
                      }}
                      onBlur={handleBlur}
                      error={errors.lastName && touched.lastName}
                      helperText={
                        errors.lastName && touched.lastName
                          ? errors.lastName
                          : ""
                      }
                    />
                    <FormHelperText error={true}>
                      {errors.lastName && touched.lastName
                        ? errors.lastName
                        : ""}
                    </FormHelperText>
                  </FormControl>
                </Stack>
                <FormControl variant="standard">
                  <p className="label">Email</p>
                  <Input
                    // type="email"
                    name="email"
                    id="input-with-icon-adornment"
                    placeholder="Enter your email address"
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={emailIcon} />
                      </InputAdornment>
                    }
                    value={values.email}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      const newValue = e.target.value.replace(/\s/g, ""); // Remove all spaces
                      handleChange({
                        target: {
                          name: "email",
                          value: newValue,
                        },
                      });
                      if (touched.email) {
                        setFieldTouched("email", false); // Clear touched state
                      }
                    }}
                    error={errors.email && touched.email}
                    helperText={
                      errors.email && touched.email ? errors.email : ""
                    }
                  />
                  <FormHelperText error={true}>
                    {errors.email && touched.email ? errors.email : ""}
                  </FormHelperText>
                </FormControl>
                <FormControl variant="standard">
                  <p className="label">Telephone</p>
                  <Input
                    name="phoneNumber"
                    type="tel"
                    placeholder="Enter your telephone number"
                    id="input-with-icon-adornment"
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={phoneIcon} alt="phone icon" />
                        <span className="country-code">+1</span>
                      </InputAdornment>
                    }
                    value={values.phoneNumber}
                    onChange={(e) => {
                      handlePhoneNumberChange(e);
                      if (touched.phoneNumber) {
                        setFieldTouched("phoneNumber", false); // Clear touched state
                      }
                    }}
                    onBlur={handleBlur}
                    error={errors.phoneNumber && touched.phoneNumber}
                    helperText={
                      errors.phoneNumber && touched.phoneNumber
                        ? errors.phoneNumber
                        : ""
                    }
                  />

                  <FormHelperText error={true}>
                    {errors.phoneNumber && touched.phoneNumber
                      ? errors.phoneNumber
                      : ""}
                  </FormHelperText>
                </FormControl>
                <FormControl variant="standard">
                  <p className="label">Password</p>
                  <Input
                    name="password"
                    ref={inputRef}
                    id="outlined-adornment-password"
                    placeholder="Enter your password"
                    type={!showPassword ? "text" : "password"}
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={LockIcon} />
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? (
                            <img src={VisibilityOff} />
                          ) : (
                            <img src={Visibility} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    value={values.password}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldTouched("password", true);
                    }}
                    error={errors.password && touched.password}
                    helperText={
                      errors.password && touched.password ? errors.password : ""
                    }
                  />
                  {/* <FormHelperText error={true}>
                    {errors.password && touched.password ? errors.password : ""}
                  </FormHelperText> */}
                  <Box className="password-instruction">
                    <p
                      style={{
                        color:
                          values.password === ""
                            ? "inherit"
                            : values.password.length >= 7
                            ? "green"
                            : (errors.password ===
                                "Password must be at least 7 characters" &&
                                touched.password) ||
                              values.password.length > 0
                            ? "#d32f2f"
                            : "inherit",
                      }}
                    >
                      - Min 7 characters
                    </p>
                    <p
                      style={{
                        color:
                          values.password === ""
                            ? "inherit"
                            : /[a-z]/.test(values.password) &&
                              /[A-Z]/.test(values.password)
                            ? "green"
                            : ((errors.password ===
                                "Password must contain at least one lowercase letter" ||
                                errors.password ===
                                  "Password must contain at least one uppercase letter") &&
                                touched.password) ||
                              values.password.length > 0
                            ? "#d32f2f"
                            : "inherit",
                      }}
                    >
                      - Upper & lower characters
                    </p>
                    <p
                      style={{
                        color:
                          values.password === ""
                            ? "inherit"
                            : /\d/.test(values.password)
                            ? "green"
                            : (errors.password ===
                                "Password must contain at least one number" &&
                                touched.password) ||
                              values.password.length > 0
                            ? "#d32f2f"
                            : "inherit",
                        marginBottom: "0px",
                      }}
                    >
                      - At least one digit
                    </p>
                  </Box>
                </FormControl>

                <FormControl variant="Input">
                  <p className="label">Confirm Password</p>
                  <Input
                    name="confirmPassword"
                    placeholder="Re-enter password"
                    id="outlined-adornment-password"
                    type={!confirmshowPassword ? "text" : "password"}
                    ref={inputRefconf}
                    onBlur={handleBlur}
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={LockIcon} />
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPasswordConfirm}
                          onMouseDown={handleMouseDownPasswordconfirm}
                          edge="end"
                        >
                          {confirmshowPassword ? (
                            <img src={VisibilityOff} />
                          ) : (
                            <img src={Visibility} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    value={values.confirmPassword}
                    onChange={(e) => {
                      handleChange(e);
                      if (touched.confirmPassword) {
                        setFieldTouched("confirmPassword", false); // Clear touched state
                      }
                    }}
                    error={errors.confirmPassword && touched.confirmPassword}
                    helperText={
                      errors.confirmPassword && touched.confirmPassword
                        ? errors.confirmPassword
                        : ""
                    }
                  />
                  <FormHelperText error={true}>
                    {errors.confirmPassword && touched.confirmPassword
                      ? errors.confirmPassword
                      : ""}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  sx={{ ".form-box.login &": { mb: "5px !important" } }}
                  variant="standard"
                >
                  <p className="label">Are you human?</p>

                  <Input
                    name="captcha"
                    // id="captcha"
                    placeholder="Enter the captcha below"
                    id="user_captcha_input"
                    type="text"
                    // value={values.captcha}

                    onChange={(e) => {
                      const uppercaseValue = e.target.value.toUpperCase();
                      setCaptchaInput(e.target.value);
                      setValues((prevValues) => ({
                        ...prevValues,
                        captcha: e.target.value.toUpperCase(),
                      }));
                      handleChange({
                        ...e,
                        target: {
                          ...e.target,
                          value: uppercaseValue,
                        },
                      });
                      if (touched.captcha) {
                        setFieldTouched("captcha", false); // Clear touched state
                      }
                    }}
                    error={errors.captcha && touched.captcha}
                    helperText={
                      errors.captcha && touched.captcha ? errors.captcha : ""
                    }
                    startAdornment={
                      <InputAdornment position="start" sx={{ mr: "10px" }}>
                        <img src={captchaIcon} />
                      </InputAdornment>
                    }
                    inputProps={{
                      style: {
                        textTransform: captchaInput ? "uppercase" : "none", // Apply uppercase only if necessary
                      },
                    }}
                  />

                  <FormHelperText error={true}>
                    {errors.captcha && touched.captcha ? errors.captcha : ""}
                  </FormHelperText>
                </FormControl>

                <Captcha
                  onChangeCaptcha={handleCaptchaChange}
                  ref={captchaRef}
                />

                {/* <div className="captacha-box">
                  <LoadCanvasTemplate />
                </div> */}

                {/* <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  spacing={2}
                >
                  <Box>
                    <FormControlLabel
                      className="checkbox"
                      control={<Checkbox sx={{ color: "gray" }} />}
                      label="Remember me"
                    />
                  </Box>
                  <Link className="link" to={FORGOT_PASSWORD} underline="none">
                    {"Forgot Password"}
                  </Link>
                </Stack> */}
                <Button
                  sx={{ mt: "20px !important" }}
                  className="login-btn"
                  variant="contained"
                  size="large"
                  type="submit"
                  disabled={loading}
                >
                  {loading && <CustomLoader loading={loading} />}
                  Register
                </Button>
                <p className="account">
                  Already have an account?&nbsp;
                  <Link className="link" to={SIGNIN_ROUTE} underline="none">
                    Login
                  </Link>
                </p>
              </Box>
            </Box>
          </Grid>
          {flag && (
            <CreateNewAccountModel
              open={flag}
              handleClose={handleClose}
              message={
                " Thank you for registering. Please check your email for the confirmation email and follow the instructions for validating your email."
              }
            />
          )}
        </Grid>
      </Box>
    </>
  );
};

export default Signup;
